export enum TipoCuenta {
    // Inderterminado = 0,
    Contado = 1,
    CuentaCorriente = 2,
    PrevioPago = 3,
    Donacion = 4,
    ConsumoInterno = 5,
    Anticipada = 6
}